<template>
  <section class="flex flex-col mb-8">
    <span
      class="flex-grow flex flex-col sm:flex-row text-gray-600 items-center"
    >
      <span
        class="flex-grow flex flex-col sm:flex-row text-gray-600 items-center"
      >
        <span class="flex text-gray-600 items-center">
          <span class="w-full sm:w-auto">EMAIL JOB</span>
          <select
            class="form-field-no-icon sm:ml-2 w-full sm:w-48 mb-2 sm:mb-0 uppercase"
            v-model="currentEmailJob"
            @change="onSelectEmailJob($event.target.value)"
            name="emailJobdrp"
          >
            <option v-for="jobItem in emailJob" :key="jobItem" :value="jobItem">
              {{ jobItem }}
            </option>
          </select>
        </span>
        <span
          class="flex text-gray-600 items-center"
          v-if="filters.emailJob != 'Real-time'"
        >
          <span class="w-full sm:w-auto sm:ml-16">SERVICE</span>
          <select
            class="form-field-no-icon sm:ml-2 w-full sm:w-48 mb-2 sm:mb-0 uppercase"
            v-model="filters.service"
          >
            <option :value="''">ANY</option>
            <option v-for="service in services" :key="service" :value="service">
              {{ serviceMappings[service] }}
            </option>
          </select>
        </span>
        <span class="w-full sm:w-auto sm:ml-16">TYPE</span>

        <select
          class="form-field-no-icon sm:ml-2 w-full sm:w-48 mb-2 sm:mb-0 uppercase"
          v-model="filters.type"
        >
          <option :value="''">ANY</option>
          <option v-for="type in types" :key="type" :value="type">
            {{ type }}
          </option>
        </select>

        <span
          v-if="singleUser && isStaff"
          class="flex text-gray-600 items-center"
        >
          <span class="w-full sm:w-auto sm:ml-16">DATE RANGE</span>
          <div
            class="date-range flex items-center gap-1 border form-field-no-icon rounded-md p-2 w-full sm:w-auto sm:ml-2 cursor-pointer"
            @click="handleClick"
          >
            <svg
              class="w-5 h-5 text-gray-600"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>

            <input
              ref="startInput"
              v-model="filters.start_date"
              type="date"
              @click.stop.prevent
              class="bg-transparent text-sm text-center outline-none border-none appearance-none pointer-events-none w-[110px] h-6 px-1"
            />

            <span class="text-md flex items-center">
              to
            </span>

            <input
              ref="endInput"
              v-model="filters.end_date"
              type="date"
              @click.stop.prevent
              class="bg-transparent text-sm text-center outline-none border-none appearance-none pointer-events-none w-[110px] h-6 px-1"
            />
          </div>
        </span>

        <span class="flex text-gray-600 items-center" v-if="singleUser && isParent && !isStaff">
          <span class="w-full sm:w-auto sm:ml-16">Users</span>
          <select class="form-field-no-icon sm:ml-2 w-full sm:w-48 mb-2 sm:mb-0 uppercase" v-model="filters.users">
            <option :value="''">ALL</option>
            <option :value="userData.id">{{userData.email}}</option>
            <option v-for="user in users" :key="user.id" :value="user.id">
              {{ user['email'] }}
            </option>
          </select>
        </span>
      </span>

      <SearchInput v-if="!singleUser" v-model="filters.search" />
    </span>
  </section>

</template>

<script>
import { ref, reactive } from "vue";
import formMixin from "@/mixins/formMixin";
import { mapGetters } from "vuex";
import SearchInput from "@/components/common/SearchInput";

export default {
  name: "UsageFilters",
  mixins: [formMixin],
  components: { SearchInput },
  props: {
    singleUser: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const services = ref(["evaluation", "threat_evaluation", "verification", "deliverability", "threat_assessment"]);
    const types = ref(["UI", "API"]);
    const emailJob = ref(["Batch", "Real-time"]);
    const currentEmailJob = "Batch";
    const users = ref([]);
    const filters = reactive({
      service: "",
      type: "",
      search: "",
      emailJob: "",
      users: "",
      start_date: "",
      end_date: "",
    });
    const serviceMappings = {
      evaluation: "Evaluation",
      threat_evaluation: "Threat Evaluation",
      verification: "Deliverability + Threat Detection",
      deliverability: "Deliverability Check",
      threat_assessment: "Threat Detection",
    };
    return { services, types, filters, emailJob, users, currentEmailJob, serviceMappings };
  },
  computed: {
    ...mapGetters({
      isStaff: "auth/isStaff",
      userData: "auth/userData",
      isParent: "auth/isParent",
    }),
  },
  beforeMount() {
    if (this.$props.singleUser) {
      this.services.splice(1, 1);
      delete this.serviceMappings.threat_evaluation;
    }
    this.fetchUsers();
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal) {
        let payload = { ...newVal };
        if (payload.start_date && !payload.end_date) {
          payload.end_date = new Date().toISOString().split("T")[0];
        }

        if (!payload.start_date) {
          payload.start_date = "";
          payload.end_date = "";
        }
        this.$emit("onFilter", payload);
      },
    },
  },
  methods: {
    onFilter() {
      this.$emit("onFilter", this.filters);
    },
    handleClick(e) {
      const container = e.currentTarget;
      const rect = container.getBoundingClientRect();
      const clickX = e.clientX - rect.left;

      const mid = rect.width / 2;

      if (clickX < mid) {
        this.$refs.startInput.showPicker();
      } else {
        this.$refs.endInput.showPicker();
      }
    },
    onSelectEmailJob(job) {
      this.currentEmailJob = job;
      this.filters.emailJob = job;
      this.filters.type = "";
      this.filters.users = "";
    },
    async fetchUsers() {
      const response = await this.$store.dispatch("fetching/FETCH", {
        apiCall: async () => await this.$alfredService.get_user(),
      });
      this.users = response;
    },
  },
};
</script>
<style>
input:focus,
input[type="radio"]:focus {
  --tw-ring-color: #ff5a5f;
  border-color: #ff5a5f;
}

input[type="radio"] {
  color: var(--hover-color);
}

.date-range input[type="date"] {
  -webkit-appearance: none;
  appearance: none;
  text-align: center;
}

.date-range input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}

</style>
